import React from "react";
import { Checkbox, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import { IOtherControl } from "../../../models/configuration/plugin/IConfiguration";
import {
    StyledCard,
    StyledCardContent,
    ControlsContainer,
    StyledFormControlLabel,
    StyledTypography,
    StyledSelect,
    StyledTextField
} from './ControlDetails.styles';
import { DtAutocomplete } from "../../ui/autocomplete";

interface controlDetailProps {
    selectedControl: IOtherControl | null,
    handleOnEnabledChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    handleOnBehaviorChange: (event: SelectChangeEvent) => void,
    handleOnCaptionChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

const ControlDetails: React.FC<controlDetailProps> =
    ({ selectedControl, handleOnEnabledChange, handleOnBehaviorChange, handleOnCaptionChange }) => {

        const behaviorOptions = [
            { value: "Visible", label: "Hide" },
            { value: "Enabled", label: "Show" }
        ];

        const selectedValue = behaviorOptions.find(opt => opt.value === selectedControl?.ControlBehavior) || null;

        return (
            <ControlsContainer sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
               
                <DtAutocomplete
                    options={behaviorOptions}
                    getOptionLabel={(option) => option.label}
                    value={selectedValue ?? behaviorOptions[0]} // <-- must be the same object from options
                    onChange={(_event, newValue) => {
                        if (newValue) {
                            handleOnBehaviorChange({
                                target: { value: newValue.value }
                            } as any);
                        }
                    }}
                    textFieldProps={{
                        label: "Non-Selected Persona",
                        size: "small",
                        variant: "outlined",
                        fullWidth: true,
                    }}
                    sx={{ minWidth: '16vw'}}
                />

                <TextField
                    label="Caption"
                    onChange={handleOnCaptionChange}
                    variant="outlined"
                    size="small"
                    value={selectedControl?.Caption ?? ""}
                    sx={{ minWidth: '24vw' }}
                />

                 <StyledFormControlLabel
                    control={
                        <Checkbox
                            onChange={handleOnEnabledChange}
                            checked={selectedControl?.Enabled ?? false}
                        />
                    }
                    label="Enabled"
                />

            </ControlsContainer>

        );
    }

export default ControlDetails;